var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.1998C12.9764 16.1998 16.2 12.9763 16.2 8.9998C16.2 5.02335 12.9764 1.7998 9 1.7998C5.02355 1.7998 1.8 5.02335 1.8 8.9998C1.8 12.9763 5.02355 16.1998 9 16.1998ZM12.3364 7.8362C12.6879 7.48473 12.6879 6.91488 12.3364 6.56341C11.9849 6.21194 11.4151 6.21194 11.0636 6.56341L8.1 9.52701L6.9364 8.36341C6.58493 8.01194 6.01508 8.01194 5.66361 8.36341C5.31213 8.71488 5.31213 9.28473 5.66361 9.6362L7.4636 11.4362C7.81508 11.7877 8.38492 11.7877 8.7364 11.4362L12.3364 7.8362Z",
    fill: "#17C964"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.020b2c70cfde730d22b4c5b5a5619c62.svg";
export { ForwardRef as ReactComponent };